import React from 'react';
import { IconChevronLeft, IconChevronRight } from './Icons';

export function Pagination({ totalCount, skip, limit, onChange }) {
  const total = Number(totalCount) || 0;
  const lim = Math.max(1, Number(limit) || 10);
  const sk = Math.max(0, Number(skip) || 0);
  const page = Math.floor(sk / lim) + 1;
  const pageCount = Math.max(1, Math.ceil(total / lim));

  function go(p) {
    const nextSkip = (p - 1) * lim;
    onChange({ skip: nextSkip, limit: lim });
  }

  const hasMultiplePages = total > lim;
  const onLaterPage = sk > 0;
  if (!hasMultiplePages && !onLaterPage) return null;

  return (
    <div className="admin-table-pagination-footer p-3 border-top bg-white">
      <nav className="admin-pagination d-flex flex-wrap align-items-center justify-content-between gap-3" aria-label="Pagination">
        <p className="admin-pagination-meta mb-0">
          {total === 0 ? (
            'No results'
          ) : (
            <>
              <span className="admin-pagination-meta-strong">
                {sk + 1}–{Math.min(sk + lim, total)}
              </span>
              <span className="text-secondary"> of </span>
              <span className="admin-pagination-meta-strong">{total}</span>
            </>
          )}
        </p>
        <div className="admin-pagination-controls d-flex align-items-center gap-1">
          <button
            type="button"
            className="admin-page-btn"
            disabled={page <= 1}
            onClick={() => go(page - 1)}
            aria-label="Previous page"
          >
            <IconChevronLeft size={18} />
          </button>
          <span className="admin-page-indicator" aria-current="page">
            {page}
            <span className="text-secondary fw-normal"> / </span>
            {pageCount}
          </span>
          <button
            type="button"
            className="admin-page-btn"
            disabled={page >= pageCount}
            onClick={() => go(page + 1)}
            aria-label="Next page"
          >
            <IconChevronRight size={18} />
          </button>
        </div>
      </nav>
    </div>
  );
}
